import { useState, useEffect, useCallback } from 'react'
import { isValidPhone } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks'
import { checkIsMobile } from '../api'

export const useCheckIsMobileNumber = (initialPhoneValue?: string) => {
  const [isMobileNumber, setIsMobileNumber] = useState<boolean>(false)
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const [phoneValue, setPhoneValue] = useState<string | undefined>(
    initialPhoneValue,
  )

  const execute = useCallback(
    (phoneValue: string) => {
      if (status != 'pending') {
        setPhoneValue(phoneValue)
      }
    },
    [status],
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (phoneValue && isValidPhone(phoneValue)) {
        setStatus('pending')
        try {
          const result = await dispatch(checkIsMobile({ number: phoneValue }))

          if (checkIsMobile.fulfilled.match(result)) {
            const { payload } = result
            setIsMobileNumber(payload)
          }
        } catch (error) {
          setIsMobileNumber(false)
          if (mounted) {
            setStatus('fail')
          }
        } finally {
          setStatus('idle')
        }
      } else {
        setIsMobileNumber(false)
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [phoneValue, dispatch])

  return { isMobileNumber, execute, status }
}
